// src/Main.jsx

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Main = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/main/mypage');
  }, [navigate]);

  return null;
};

export default Main;
